export function RawPanel({ payload, stale }: { payload: unknown; stale?: boolean }) {
  if (stale) {
    return (
      <p className="muted small">
        工具结果已过期（进程重启或会话历史只保留了摘要）。重新跑一次以查看完整数据。
      </p>
    );
  }
  if (!payload) {
    return <p className="muted small">没有可视化内容。</p>;
  }
  if (typeof payload === "string") {
    return <pre className="raw-panel">{payload}</pre>;
  }
  if (typeof payload === "object" && payload !== null && "text" in payload) {
    const text = (payload as { text?: unknown }).text;
    if (typeof text === "string") {
      return <pre className="raw-panel">{text}</pre>;
    }
  }
  return (
    <pre className="raw-panel">{JSON.stringify(payload, null, 2)}</pre>
  );
}
